var giphy_viewer_default = {
  "giphyWrapper": "fi8m2",
  "giphy_player": "-FqPq",
  "playIcon": "_1TIVi",
  "gifRatio": "jUZJm"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
